// extracted by mini-css-extract-plugin
module.exports = {"measure-unit-selector__tooltip":"shortened-measure-unit-selector-body_measure-unit-selector__tooltip__FK84B"};